"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADMIN_MANIFEST_URL_PATTERN = exports.ENDUSER_MANIFEST_URL_PATTERN = void 0;
exports.createManifestRoute = createManifestRoute;
const app_1 = require("@aurora/shared-types/app");
const path_to_regexp_1 = require("path-to-regexp");
const UrlHelper_1 = __importStar(require("../helpers/urls/UrlHelper/UrlHelper"));
/**
 * URL pattern for the manifest route used by enduser-app
 */
exports.ENDUSER_MANIFEST_URL_PATTERN = '/manifest.webmanifest/:themeId/:themeLastModified';
/**
 * URL pattern for the manifest route used by admin-app
 */
exports.ADMIN_MANIFEST_URL_PATTERN = `/admin${exports.ENDUSER_MANIFEST_URL_PATTERN}`;
function compileRoute(urlPattern) {
    return (0, path_to_regexp_1.compile)(urlPattern, {
        encode: UrlHelper_1.safeEncodeUriComponent
    });
}
const endUserManifestRoute = compileRoute(exports.ENDUSER_MANIFEST_URL_PATTERN);
const adminManifestRoute = compileRoute(exports.ADMIN_MANIFEST_URL_PATTERN);
/**
 * Creates a manifest route for a given app type and specified params
 *
 * @param appType the app type
 * @param tenant the tenant
 * @param params the params used to build the manifest route
 */
function createManifestRoute(appType, tenant, params) {
    const route = appType === app_1.AppType.ADMIN ? adminManifestRoute(params) : endUserManifestRoute(params);
    return UrlHelper_1.default.prefixBasePath(tenant, route);
}
//# sourceMappingURL=manifestRoute.js.map